import type { LayoutPageConfig } from './types';

export const reportingPageConfig = {
  namespacesRequired: ['reporting'],
  layout: {
    showHeaderPeriodFilter: false,
  },
} satisfies LayoutPageConfig;
